import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import WixComponent from '../../../BaseComponents/WixComponent';
import PropTypes from 'prop-types';
import { DropTarget } from 'react-dnd';
import { dragCoordinates } from '../DragUtils';
import { ItemTypes } from '../types';
/* eslint-disable new-cap */

var getRelativePositions = function getRelativePositions(child, parent) {
  var topPositionOfChild = child.getBoundingClientRect().top - parent.getBoundingClientRect().top;
  var bottomPositionOfChild = topPositionOfChild + child.getBoundingClientRect().height;
  return {
    top: topPositionOfChild,
    bottom: bottomPositionOfChild
  };
};

var target = {
  drop: function drop(props, monitor) {
    /** if drop was already done(on child), we skip this drop call */
    if (monitor.getDropResult()) {
      return;
    }

    return {
      containerId: props.containerId,
      groupName: props.groupName,
      index: monitor.getItem().index
    };
  },
  canDrop: function canDrop(props) {
    return props.droppable;
  },
  hover: function hover(props, monitor, component) {
    if (!component) {
      return;
    }
    /**
      in this block we check that user dragging item over container empty pars
      and not over other draggable(sortable items)
    */


    var _getRelativePositions = getRelativePositions(component.childNode, component.rootNode),
        top = _getRelativePositions.top,
        bottom = _getRelativePositions.bottom;

    var _dragCoordinates = dragCoordinates({
      monitor: monitor,
      component: component
    }),
        hoverClientY = _dragCoordinates.hoverClientY;

    var isHoverInBannedArea = hoverClientY > top && hoverClientY < bottom || !monitor.isOver();

    if (isHoverInBannedArea) {
      return;
    }
    /** end of block */

    /**
      in this block we check, that user dragging item(from some container with group)
      over container with same group
    */


    var monitorItem = monitor.getItem();
    var isSameGroup = props.groupName && monitorItem.groupName && props.groupName === monitorItem.groupName;

    if (!props.droppable || !isSameGroup || !component) {
      return;
    }
    /** end of block */


    var dragIndex = monitorItem.index; // position of item that we drag in items array

    var hoverIndex = hoverClientY < top ? 0 : props.total; // if user drag item above other items - add to the top, otherwise - add to the bottom

    var isSameContainer = props.containerId === monitorItem.realTime.containerId; // check do we hover over same container(from which item is)

    /** in case that we hover over itself - do nothing */

    if (!component || hoverIndex === dragIndex && isSameContainer) {
      return;
    }
    /**
      if item is from same group but different container, that's mean that we move item
      from one container to another, and we need to move out item from previous container
    */


    if (isSameGroup && !isSameContainer) {
      monitorItem.realTime.onMoveOut(monitorItem.id);
    }
    /**
      as react-dnd store same snapshot in monitor(so containerId of item will be same, even if we moved it with hover to another container)
      after any hovers, we need to save also real position of monitor, with real links to current container
    */


    monitorItem.realTime.onMoveOut = props.onMoveOut;
    monitorItem.realTime.onDrop = props.onDrop;
    monitorItem.realTime.containerId = props.containerId;
    /**
      call callback, to ask parent to do some action, for example swap items or add new one,
      we send original position of item and new one, also id of item and original item state(
        it required for case, when we moving item from 1 container to another
      )
    */

    props.onHover({
      removedIndex: dragIndex,
      addedIndex: hoverIndex,
      id: monitorItem.id,
      item: monitorItem.originalItem
    });
    /** set new index for item */

    monitor.getItem().index = hoverIndex;
  }
};

var Container = /*#__PURE__*/function (_WixComponent) {
  _inherits(Container, _WixComponent);

  var _super = _createSuper(Container);

  function Container() {
    var _this;

    _classCallCheck(this, Container);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "setRootRef", function (node) {
      return _this.rootNode = node;
    });

    _defineProperty(_assertThisInitialized(_this), "setChildRef", function (node) {
      return _this.childNode = node;
    });

    return _this;
  }

  _createClass(Container, [{
    key: "render",
    value: function render() {
      if (!this.props.connectDropTarget) {
        return null;
      }

      return this.props.connectDropTarget( /*#__PURE__*/React.createElement("div", {
        className: this.props.className,
        ref: this.setRootRef
      }, /*#__PURE__*/React.cloneElement(this.props.children, {
        ref: this.setChildRef
      })));
    }
  }]);

  return Container;
}(WixComponent);

Container.propTypes = {
  children: PropTypes.element.isRequired,
  className: PropTypes.string,
  containerId: PropTypes.string,
  groupName: PropTypes.string,
  index: PropTypes.number,
  onMoveOut: PropTypes.func,
  onDrop: PropTypes.func,
  onHover: PropTypes.func,
  droppable: PropTypes.bool
};
Container.defaultProps = {
  droppable: true
};
export default DropTarget(ItemTypes.DRAGGABLE, target, function (connect) {
  return {
    connectDropTarget: connect.dropTarget()
  };
})(Container);